import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  DOCUMENT,
  inject
} from '@angular/core';
import { NowModal } from '@now/dpl';

@Component({
  selector: 'now-wbsuche-lib-modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['modal-popup.component.scss'],
  imports: []
})
export class ModalPopupComponent implements OnDestroy, AfterViewInit {
  private readonly document = inject<Document>(DOCUMENT);

  @Output()
  primaryButtonClick = new EventEmitter<boolean>();

  @Output()
  secondaryButtonClick = new EventEmitter<boolean>();

  @Input({ required: true })
  modalId!: string;

  @Input()
  modalTitle!: string;

  @Input()
  modalSubtitle?: string;

  @Input()
  primaryButtonText = 'Akzeptieren';

  @Input()
  secondaryButtonText = 'Abbrechen';

  @Input()
  additionalModalClasses = '';

  @Input()
  additionalHeaderClasses = '';

  @Input()
  center = false;

  @Input()
  primaryBeforeSecondary = true;

  @Input()
  ariaLabel?: string;

  private modal?: NowModal;

  ngAfterViewInit(): void {
    const modalElement = this.document.getElementById(this.modalId)!;

    this.modal = NowModal.init(modalElement);
  }

  /**
   * Schließt das Modal, falls es noch geöffnet wird,
   * bevor alle Angular-Referenzen darauf zerstört werden.
   */
  ngOnDestroy(): void {
    this.modal?.hide();
    this.modal?.dispose();
  }

  public openModal() {
    this.modal?.show();
  }
}
